import { action, observable } from 'mobx';

class ExclusionListStore {
  public static generateFromApiResponse(responses: any[]): number[] {
    const exclusionLists: number[] = [];
    responses.forEach(response => {
      exclusionLists.push(response);
    });
    return exclusionLists;
  }

  @observable public exclusionLists: number[];
  @observable public isLoading: boolean = true;
  @observable public updatingOrganizationId: string = '';

  @action
  public setExclusionList(responses: any): void {
    this.exclusionLists = ExclusionListStore.generateFromApiResponse(responses);
  }

  @action
  public setLoading(isLoading: boolean, updatingOrganizationId: string): void {
    this.isLoading = isLoading;
    this.updatingOrganizationId = updatingOrganizationId;
  }
}

export default ExclusionListStore;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/domain/store/ExclusionListStore.ts